var React = require('react');

function Ar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.87 0H0V16.9H1.8V1.8H16.87V0ZM65.9599 1.82002H50.8699V0.0200195H67.7599V16.88H65.9599V1.82002ZM65.9499 65.9799V50.8799H67.7499V67.7799H50.8799V65.9799H65.9499ZM1.81001 65.9599V50.8999H0.0100098V67.7599H16.9V65.9599H1.81001ZM50.9448 18.6594L32.1632 12.48L15.4548 24.2815V45.8982L34.3492 51.8754L50.9448 40.271V18.6594ZM34.0503 29.4145L18.3069 24.434L32.4565 14.4398L48.1035 19.5879L34.0503 29.4145ZM33.3149 31.0383L17.2248 25.9482V44.6016L33.3149 49.6917V31.0383ZM35.0849 49.2011L49.1748 39.3488V20.9985L35.0849 30.8508V49.2011Z","fill":"#1D1D1B"}));
}

Ar.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = Ar;

Ar.default = Ar;
